import { uniq } from '../../../../utils/helper/lodash_replacements';
import { Level } from '../../level/Level';
export class TopicLevels {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get topic() {
        return this.parent;
    }
    get levels() {
        return uniq(this.topic.topicMiniQuestions.miniQuestions.map(mini => mini.micro.levelTag)).map(levelTag => this.levelByTag(levelTag));
    }
    mem = new Map();
    levelByTag(name) {
        if (this.mem.has(name)) {
            return this.mem.get(name);
        }
        const s = new Level(this.topic, name);
        this.mem.set(name, s);
        return s;
    }
    get levelTags() {
        return uniq(this.levels.map(level => level.name));
    }
}
